<template>
  <h1>403 - Access denied</h1>
</template>

<script>
  export default {
    name: 'Error403View',
  };
</script>
